var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0 route-info-detailed-status",attrs:{"fluid":""}},[_c('route-tracking-history',{staticClass:"pt-4 pb-9 page-content",attrs:{"route":_vm.route}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }